if (!customElements.get('boom-vip-redeem')) {
    class BoomVipRedeem extends HTMLElement {
      constructor() {
        super();
        this.modal = null; 
       
      }
      
      connectedCallback() {
        this.initRedeemLogic();
      }
      
      initRedeemLogic() {
        const container = this.querySelector('[id^="PointsRedeem-"]');
        if (!container) return;
        this.modal = this.querySelector('[id^="CreditsModal-"]');
        const closeModalBtn = this.querySelector('[id^="CloseModal-"]');
        let userCredits = parseInt(container.getAttribute('data-user-credits')) || 0;
        let userId = container.getAttribute('data-user-id');
        const isLogin = container?.dataset?.isLogin === 'true';
        this.querySelectorAll('.redeem-btn').forEach(button => {
          button.addEventListener('click', async () => {
            const btnText = button.querySelector('.btn-text');
            const btnSpinner = button.querySelector('.btn-spinner');
            const cost = parseInt(button.getAttribute('data-cost')) || 0;
            const redeemType = button.getAttribute('data-type');
            if (!isLogin) {
              window.location.href = '/account/login';
              return;
            }
            if (userCredits < cost) {
              this.showModal(); 
              return;
            }
            
            this.setLoading(button, true, btnText, btnSpinner);
            try {
                const params = new URLSearchParams({ action: "postDiscountCode" });
                const response = await fetch(`/apps/phomemo-api/api/shopify/postDiscountCode`, {
                    method: "POST",
                    headers: { 
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "ngrok-skip-browser-warning": 69420 
                    },
                    body: JSON.stringify({
                      id:userId,
                      discountType: redeemType 
                    })
                });
                
                const result = await response.json();
                console.log("==result==", result);
                
                if (result.code == -2) {
                    this.showModal(); 
                } else if (result.code !== 1) {
                    this.showModal(`Sorry~ Redemption failed. ${result.message || ''}`);
                } else {
                    location.href = 'https://account.phomemo.com/pages/019ce51e-186c-718a-bd9b-4dd3ca60388e';
                }
            } catch (error) {
              console.error('Error during redemption:', error);
              this.showModal("An unexpected error occurred. Please try again.");
            } finally {
              this.setLoading(button, false, btnText, btnSpinner);
            }
          });
        });
        
        if (closeModalBtn && this.modal) {
          closeModalBtn.addEventListener('click', () => this.hideModal());
          this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.hideModal();
          });
        }
      }

      showModal(msg) {
        if (!this.modal) return;
        
        // 显示外层容器
        this.modal.classList.remove('hidden');
        this.modal.classList.add('flex');
        
        const titleEl = this.modal.querySelector('#CreditsModalTitle');
        if (titleEl) {
          titleEl.innerText = msg || "Oops! Looks like you need more credits to redeem this item";
        }
        
        setTimeout(() => {
          this.modal.firstElementChild.classList.remove('scale-95');
          this.modal.firstElementChild.classList.add('scale-100');
        }, 10);
      }

      hideModal() {
        if (!this.modal) return;
        this.modal.firstElementChild.classList.remove('scale-100');
        this.modal.firstElementChild.classList.add('scale-95');
        setTimeout(() => {
          this.modal.classList.remove('flex');
          this.modal.classList.add('hidden');
        }, 150);
      }

      setLoading(btn, isLoading, textEl, spinnerEl) {
        if (isLoading) {
          btn.disabled = true;
          textEl.classList.add('hidden');
          spinnerEl.classList.remove('hidden');
        } else {
          btn.disabled = false;
          textEl.classList.remove('hidden');
          spinnerEl.classList.add('hidden');
        }
      }
    }
    
    customElements.define('boom-vip-redeem', BoomVipRedeem);
}